import { useContext } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiContext } from '@shared/contexts';
import { TGetAccessLogsResult } from '../types/accessLogs.types';
import { ACCESS_LOGS_ENDPOINT, ACCESS_LOGS_QUERY_KEY } from '../constants';

export const useAccessLogs = ({ page, pageSize }: { page: number; pageSize: number }) => {
  const { apiClient, useHandleQueryError, retry } = useContext(ApiContext);

  const queryFn = async () => {
    if (!page || !pageSize) return;
    const { data } = await apiClient.get<TGetAccessLogsResult>(ACCESS_LOGS_ENDPOINT, {
      params: { page: page - 1, pageSize },
    });
    return data;
  };

  const isFirstPage = !page || page <= 1;
  const q = useQuery({
    queryKey: [ACCESS_LOGS_QUERY_KEY, page, pageSize],
    enabled: !!page && !!pageSize,
    queryFn,
    retry,
    refetchOnWindowFocus: isFirstPage,
    refetchOnReconnect: isFirstPage,
    placeholderData: keepPreviousData,
  });

  useHandleQueryError(q.isError, q.error, `Failed to load access logs on page ${page}!`);
  return { data: q.data, isLoading: q.isLoading, error: q.error };
};
